//Custom components
import { NumericFormat as NumberFormat } from 'react-number-format';
import StatCard from '../../../UI/Card/StatCard';

const ToBeInspectedWidget = ({ count }: { count: string | number }) => {
  return <StatCard title='To Be Inspected' stat={<NumberFormat value={count} displayType='text' thousandSeparator={true} />} />;
};

export default ToBeInspectedWidget;
